export default __webpack_public_path__ + "static/proxima-nova-100-c769fb3d3f164c2b7c11215e110b6ff7.woff";